const config = {
    apiUrl: 'https://buy-api.addy.co/api/buying/v1',
};

export default config;
